export default __webpack_public_path__ + "static/media/sv.26bae9ea.svg";